module.exports = "/_next/static/images/bulk-change-2fa-1064b4711acff74bfccbeff87d55bff3.png";